import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ttPaymentLogList: [],
    operationObj: { type: '', status: '' },
    isLoading: false,
    totalElements: 0,
    // Detail (by control number) state
    ttPaymentLogDetailList: [],
    detailOperationObj: { type: '', status: '' },
    isDetailLoading: false,
};

export const TTPaymentLogSlice = createSlice({
    name: 'ttPaymentLogReducer',
    initialState,
    reducers: {
        updateTTPaymentLogList: (state, action) => {
            state.ttPaymentLogList = action.payload;
        },
        updateTTPaymentLogOperationObj: (state, action) => {
            state.operationObj = action.payload;
        },
        updateTTPaymentLogIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        updateTTPaymentLogTotalElements: (state, action) => {
            state.totalElements = action.payload;
        },
        updateTTPaymentLogDetailList: (state, action) => {
            state.ttPaymentLogDetailList = action.payload;
        },
        updateTTPaymentLogDetailOperationObj: (state, action) => {
            state.detailOperationObj = action.payload;
        },
        updateTTPaymentLogDetailIsLoading: (state, action) => {
            state.isDetailLoading = action.payload;
        },
    },
});

export const {
    updateTTPaymentLogList,
    updateTTPaymentLogOperationObj,
    updateTTPaymentLogIsLoading,
    updateTTPaymentLogTotalElements,
    updateTTPaymentLogDetailList,
    updateTTPaymentLogDetailOperationObj,
    updateTTPaymentLogDetailIsLoading,
} = TTPaymentLogSlice.actions;

// Selector
export const getTTPaymentLogSelector = (state) => state.ttPaymentLogReducer;

export default TTPaymentLogSlice.reducer;